import React from "react";
import { SketchPicker } from "react-color";
import { Constants } from "../../../../common/constants";
import fontColorContrast from "font-color-contrast";
import { ModifySettingsButton } from "./improved_components/base_components/modify_settings_button";
import classNames from "classnames";

const PRESET_COLORS = [
	{ color: Constants.EMBED_COLOR, title: "sesh" },
	"#D0021B",
	"#F5A623",
	"#F8E71C",
	"#8B572A",
	"#7ED321",
	"#417505",
	"#BD10E0",
	"#9013FE",
	"#4A90E2",
	"#50E3C2",
	"#B8E986",
	"#000000",
	"#4A4A4A",
	"#9B9B9B",
	"#FFFFFF",
];

interface ColorPickerProp {
	name?: string;
	value: string;
	updateFunc: Function;
	disabled?: boolean;
}

interface ColorPickerState {
	intermediate_color: string;
	picker_showing: boolean;
}

export class ColorPickerForm extends React.Component<
	ColorPickerProp,
	ColorPickerState
> {
	constructor(props) {
		super(props);

		this.state = {
			intermediate_color: this.props.value,
			picker_showing: false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeDrag = this.handleChangeDrag.bind(this);
		this.onColorSwatchClicked = this.onColorSwatchClicked.bind(this);
		this.onDivClicked = this.onDivClicked.bind(this);
	}

	handleChange(event) {
		this.setState({ intermediate_color: event.hex });
		this.props.updateFunc(event.hex);
	}

	componentDidUpdate(
		prevProps: Readonly<ColorPickerProp>,
		prevState: Readonly<ColorPickerState>,
		snapshot?: any
	): void {
		// value was updated
		if (prevProps.value !== this.props.value) {
			if (prevState.intermediate_color !== this.props.value) {
				this.setState({ intermediate_color: this.props.value });
			}
		}
	}

	handleChangeDrag(event) {
		this.setState({ intermediate_color: event.hex });
	}

	onClick(event) {
		event.preventDefault();
		event.preventDefault();
		event.stopPropagation();
	}

	onColorSwatchClicked(event) {
		event.preventDefault();
		event.stopPropagation();
		let new_state = !this.state.picker_showing;
		this.setState({ picker_showing: new_state });
	}

	onDivClicked(event) {
		this.setState({ picker_showing: false });
	}

	render() {
		const color_contrast = fontColorContrast(this.props.value);

		return (
			<>
				<div className="" onClick={this.onClick}>
					{this.props.name && (
						<label className="label is-size-5">
							{this.props.name}
						</label>
					)}
					<div className="flex" onClick={this.onDivClicked}>
						<div
							className="flex w-fit"
							onClick={this.onColorSwatchClicked}
						>
							<ModifySettingsButton
								disabled={this.props.disabled}
							>
								<div className="flex items-center gap-2">
									<div
										className="relative h-10 w-28 cursor-pointer rounded-md border"
										style={{
											backgroundColor: this.props.value,
											borderColor:
												color_contrast === "#000000"
													? "transparent"
													: "#00f4ff",
										}}
									>
										<div
											className="absolute inset-0 flex items-center justify-center font-mono opacity-50"
											style={{
												color: color_contrast,
											}}
										>
											{this.props.value}
										</div>
									</div>
									Modify
								</div>
							</ModifySettingsButton>
						</div>
					</div>
				</div>
				<div
					className={classNames("modal", {
						"is-active": this.state.picker_showing,
					})}
				>
					<div
						className="modal-background"
						onClick={() =>
							this.setState({
								picker_showing: false,
							})
						}
					></div>
					<div className="relative">
						<div className="sketch-picker-parent mt-4 flex flex-col items-center">
							<SketchPicker
								color={this.state.intermediate_color}
								onChange={this.handleChangeDrag}
								onChangeComplete={this.handleChange}
								disableAlpha={true}
								presetColors={PRESET_COLORS}
							/>
						</div>
					</div>
					<button
						className="modal-close is-large"
						aria-label="close"
						onClick={(e) => {
							e.preventDefault();
							this.setState({
								picker_showing: false,
							});
						}}
					></button>
				</div>
			</>
		);
	}
}
